var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.554,
    height: 14.542,
    viewBox: "0 0 20.554 14.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_824a98e48304272f3fcbd32317ad8001",
    "data-name": "824a98e48304272f3fcbd32317ad8001",
    d: "M19,14.5a.5.5,0,0,1-.5.5H3.71l3.14,3.15a.5.5,0,1,1-.7.7l-4-4A.36.36,0,0,1,2,14.69a.47.47,0,0,1,0-.38.36.36,0,0,1,.11-.16.36.36,0,0,1,.2-.15.41.41,0,0,1,.19,0h16a.5.5,0,0,1,.5.5Zm3-5a.41.41,0,0,1,0,.19.53.53,0,0,1-.27.27.41.41,0,0,1-.19,0H5.5a.5.5,0,0,1,0-1H20.29L17.15,5.85a.495.495,0,1,1,.7-.7l4,4a.36.36,0,0,1,.11.16A.41.41,0,0,1,22,9.5Z",
    transform: "translate(-1.707 -4.71)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.ee454f80a5aa2d861adad532e06b7de3.svg";
export { ForwardRef as ReactComponent };